<template>
  <ModalDefault modal_id="viewMediaModal"
                header="y"
                size="modal-xl modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_854')"
                footer="y"
                icon="bx bx-file mr-1">
    <div style="min-height: 575px; max-height: 575px;"
         class="px-2 py-2 pb-3"
         slot="body">
      <div class="row">
        <div class="col-12 text-center">
          <img :src="chat.show_media"
               style=" width: 100%; height: auto;">
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div class="pr-2">
          <a :href="chat.show_media" class="shadow-sm cursor_pointer btn-outline-primary py-2 px-3" download>
            <i class="bx bx-download pr-2"></i><span class="">{{ getTranslations('expression_855') }}</span>
          </a>
      </div>
      <div>
          <span data-dismiss="modal" class="shadow-sm cursor_pointer btn-secondary text-white py-2 px-3">
            <span class="">{{ getTranslations('expression_340') }}</span>
          </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";

export default {
  name: "ModalViewMedia",
  components: {
    ModalDefault,
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(['chat']),
    ...mapGetters([])
  },
  methods: {
    download(){
      window.open(`/media/example.xls`, '_blank');
    },
  }
}
</script>

<style scoped>

</style>
